var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy267(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M83.9,33.7c-1.8-5.1-6-8.4-10.2-10.4c-2.4-1.1-7.6-2.1-10.1-2.8c-1.5-0.4-8.8-1.3-10.3-1.3 c-0.9,0-2.8,0-3.7,0c-0.9,0-2.8,0-3.7,0c-1.5,0-8.8,0.9-10.3,1.3c-2.5,0.7-7.8,1.7-10.1,2.8c-4.7,2.3-8.3,5.3-10.2,10.4 c-1.1,3.2-1.3,6.6-0.4,9.8L19,63c1.3,5,4.9,9.1,9.7,11.1l8.4,3.5c1.3,0.5,2.6,0.9,4,1.1l0.2-2.7c0.1-1.4,1.3-2.5,2.8-2.5h5.5h5.5 c1.5,0,2.7,1.1,2.8,2.5l0.2,2.7c1.4-0.2,2.7-0.6,4-1.1l8.4-3.5c4.8-2,8.4-6.1,9.7-11.1l4.1-19.5C85.2,40.3,85,36.8,83.9,33.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 30.5,
    cy: 38,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 30.5,
    cy: 38,
    r: 4.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 68.7,
    cy: 38,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 68.7,
    cy: 38,
    r: 4.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49.6,
    cy: 65.8,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 65.4,
    cy: 67.1,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 33.8,
    cy: 67.1,
    r: 4.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy267);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-267.a107b2f04bb6e52eac1d2e4804f6a533.svg";
export { ForwardRef as ReactComponent };